export default __webpack_public_path__ + "static/media/learning.5bee31bb.svg";